export default "__VITE_ASSET__DZlztvVG__"